/* eslint-disable @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars */

import {AminoMsg} from "@cosmjs/amino";
import {AminoConverter} from "@shareledgerjs/amino";
import {Input, Output} from "@shareledgerjs/types/cosmos/bank/v1beta1/bank";
import {MsgMultiSend, MsgSend} from "@shareledgerjs/types/cosmos/bank/v1beta1/tx";
import {Coin} from "@shareledgerjs/types/cosmos/base/v1beta1/coin";

export interface AminoMsgSend extends AminoMsg {
  readonly type: "cosmos-sdk/MsgSend";
  readonly value: {
    /** Bech32 account address */
    readonly from_address: string;
    /** Bech32 account address */
    readonly to_address: string;
    readonly amount: readonly Coin[];
  };
}

export function isAminoMsgSend(msg: AminoMsg): msg is AminoMsgSend {
  return msg.type === "cosmos-sdk/MsgSend";
}

/** A high level transaction of the coin module */
export interface AminoMsgMultiSend extends AminoMsg {
  readonly type: "cosmos-sdk/MsgMultiSend";
  readonly value: {
    readonly inputs: readonly Input[];
    readonly outputs: readonly Output[];
  };
}

export function isAminoMsgMultiSend(msg: AminoMsg): msg is AminoMsgMultiSend {
  return msg.type === "cosmos-sdk/MsgMultiSend";
}

export function createBankAminoConverters(): Record<string, AminoConverter | "not_supported_by_chain"> {
  return {
    "/cosmos.bank.v1beta1.MsgSend": {
      aminoType: "cosmos-sdk/MsgSend",
      toAmino: ({fromAddress, toAddress, amount}: MsgSend): AminoMsgSend["value"] => ({
        from_address: fromAddress,
        to_address: toAddress,
        amount: [...amount]
      }),
      fromAmino: ({from_address, to_address, amount}: AminoMsgSend["value"]): MsgSend => ({
        fromAddress: from_address,
        toAddress: to_address,
        amount: [...amount]
      })
    },
    "/cosmos.bank.v1beta1.MsgMultiSend": {
      aminoType: "cosmos-sdk/MsgMultiSend",
      toAmino: ({inputs, outputs}: MsgMultiSend): AminoMsgMultiSend["value"] => ({
        inputs: inputs.map((input) => ({
          address: input.address,
          coins: [...input.coins]
        })),
        outputs: outputs.map((output) => ({
          address: output.address,
          coins: [...output.coins]
        }))
      }),
      fromAmino: ({inputs, outputs}: AminoMsgMultiSend["value"]): MsgMultiSend => ({
        inputs: inputs.map((input) => ({
          address: input.address,
          coins: [...input.coins]
        })),
        outputs: outputs.map((output) => ({
          address: output.address,
          coins: [...output.coins]
        }))
      })
    }
  };
}
